import { render, staticRenderFns } from "./MemoInboxList2.vue?vue&type=template&id=7707913e&"
import script from "./MemoInboxList2.vue?vue&type=script&lang=js&"
export * from "./MemoInboxList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports